// extracted by mini-css-extract-plugin
export default {"icon":"menuItem_icon__exvdf"};